import _ from 'lodash';

/* @ngInject */
export default class UserDataService {
    constructor(HPConfig, $http, $q) {
        this.HPConfig = HPConfig;
        this.$http = $http;
        this.$q = $q;
        this._ = _;

        this.goodStanding = true;
        this.profilePicture = '';
        this.currentLocation = null;
        this.kbygCurrentLocation = null;
        this.mainLocation = null;
        this.locationPromise = null;
        this.kbygLocationPromise = null;

        this.setupLocationPromise();
        this.setupKBYGLocationPromise();
    }

    getUserData() {
        return this.$http.get(`${this.HPConfig.heroProApi}User`, {
            cache: true,
        })
            .then(response => response.data.Data);
    }

    getHISTrainingMandate() {
        return this.$http.get(`${this.HPConfig.heroProApi}ContractorUser/GetHISTrainingMandate`, {
            cache: true,
        })
            .then(response => response.data.Data);
    }

    getTrainingDaysRemaining(trainingExpDate) {
        const gpExpire = Date.parse(trainingExpDate);
        return Math.max(0, Math.floor((gpExpire - new Date()) / 86400000)) + 1;
    }

    resetPromises() {
        const that = this;
        return this.$q((resolve) => {
            that.locationPromise = undefined;
            that.setupLocationPromise();
            that.kbygLocationPromise = undefined;
            that.setupKBYGLocationPromise();
            resolve();
        });
    }

    getUserLocations() {
        return this.locationPromise;
    }

    // (ajt 11/16/2015) Add new KBYG location lookup.
    getKBYGLocations() {
        return this.kbygLocationPromise;
    }

    getCurrentLocation() {
        const that = this; // fix with =>

        return this.$q((resolve) => {
            that.locationPromise.then(() => {
                resolve(this.currentLocation);
            });
        });
    }
    // (ajt 11/16/2015) Add support to get current KBYG location.
    getCurrentKBYGLocation() {
        return this.$q((resolve) => {
            this.kbygLocationPromise.then(() => {
                resolve(this.kbygCurrentLocation);
            });
        });
    }

    setCurrentLocation(newLocation) {
        this.currentLocation = newLocation;
    }
    // (ajt 6/3/2016) Add main location lookup.
    getMainLocation() {
        return this.$q((resolve) => {
            this.locationPromise.then(() => {
                resolve(this.mainLocation);
            });
        });
    }

    // private functions

    setupLocationPromise() {
        this.locationPromise = this.$http({
            url: `${this.HPConfig.heroProApi}Contractor/Location`,
            method: 'GET',
            params: {
                includeServiceStates: true,
                contractorStatusList: [2, 3, 10, 11],
                includeTermSets: true,
            },
        })
            .then((response) => {
                const locations = response.data.Data;
                if (locations.length === 1) {
                    this.currentLocation = locations[0];
                    if (locations[0].IsMaster) {
                        this.mainLocation = locations;
                    }
                    return locations;
                } else if (locations.length > 1) {
                    let muniIds = [];
                    _.each(locations, (loc) => {
                        if (loc.ServiceStateDetails && loc.ServiceStateDetails.length > 0) {
                            muniIds = muniIds.concat(loc.ServiceStateDetails);
                        }
                    });

                    const serviceStates = _.uniq(muniIds, muni => muni.StateGeoId);
                    const financingProducts = this.constructor.getFinancingProducts(locations);

                    const allLocations = [{
                        ContractorId: '',
                        OrganizationId: locations[0].OrganizationId,
                        LocationNickname: 'All Locations',
                        CompanyName: locations[0].CompanyName,
                        Address: locations[0].Address,
                        City: locations[0].City,
                        State: locations[0].State,
                        Zip: locations[0].Zip,
                        LicenseNumber: locations[0].LicenseNumber,
                        AccountManager: locations[0].AccountManager,
                        ContractorNumber: locations[0].ContractorNumber,
                        ContractorStatusId: locations[0].ContractorStatusId,
                        OrganizationTermSets: locations[0].OrganizationTermSets,
                        ServiceStateDetails: serviceStates,
                        FinancingProducts: financingProducts,
                    }];
                    this.currentLocation = allLocations[0];
                    this.mainLocation = _.filter(locations, location => location.IsMaster);
                    return allLocations.concat(locations);
                }
                return null;
            });
    }

    setupKBYGLocationPromise() {
        this.kbygLocationPromise = this.$http({
            url: `${this.HPConfig.heroProApi}Contractor/Location`,
            method: 'GET',
            params: {
                includeServiceStates: true,
                contractorStatusList: [2, 3, 10, 11],
                includeTermSets: true,
            },
        })
            .then((response) => {
                const locations = response.data.Data;
                let kbygLocations = [];
                if (locations.length === 1) {
                    kbygLocations = [{
                        ContractorId: locations[0].ContractorId,
                        OrganizationId: locations[0].OrganizationId,
                        LocationNickname: locations[0].LocationNickname,
                        CompanyName: locations[0].CompanyName,
                        Address: locations[0].Address,
                        City: locations[0].City,
                        State: locations[0].State,
                        Zip: locations[0].Zip,
                        LicenseNumber: locations[0].LicenseNumber,
                        ContractorStatusId: locations[0].ContractorStatusId,
                        AccountManager: locations[0].AccountManager,
                        OrganizationTermSets: locations[0].OrganizationTermSets,
                    }];
                    this.kbygCurrentLocation = kbygLocations[0];
                    return locations;
                } else if (locations.length > 1) {
                    let masterFound = false;
                    // Find the Master location
                    for (let j = 0; j < locations.length; j += 1) {
                        if (locations[j].isMaster !== undefined && locations[j].isMaster === true) {
                            kbygLocations = [{
                                ContractorId: locations[j].ContractorId,
                                OrganizationId: locations[j].OrganizationId,
                                LocationNickname: locations[j].LocationNickname,
                                CompanyName: locations[j].CompanyName,
                                Address: locations[j].Address,
                                City: locations[j].City,
                                State: locations[j].State,
                                Zip: locations[j].Zip,
                                LicenseNumber: locations[j].LicenseNumber,
                                ContractorStatusId: locations[j].ContractorStatusId,
                                AccountManager: locations[j].AccountManager,
                            }];
                            masterFound = true;
                        }
                    }
                    // If the master does not exist, default to the first location
                    if (masterFound !== true) {
                        kbygLocations = [{
                            ContractorId: locations[0].ContractorId,
                            OrganizationId: locations[0].OrganizationId,
                            LocationNickname: locations[0].LocationNickname,
                            CompanyName: locations[0].CompanyName,
                            Address: locations[0].Address,
                            City: locations[0].City,
                            State: locations[0].State,
                            Zip: locations[0].Zip,
                            LicenseNumber: locations[0].LicenseNumber,
                            ContractorStatusId: locations[0].ContractorStatusId,
                            AccountManager: locations[0].AccountManager,
                        }];
                    }
                    // Add remaining locations to array
                    if (locations.length > 1) {
                        for (let i = 1; i < locations.length; i += 1) {
                            kbygLocations.push(locations[i]);
                        }
                    }

                    // Set current location
                    this.kbygCurrentLocation = kbygLocations[0];
                    return kbygLocations;
                }
                return null;
            });
    }

    static getFinancingProducts(locations) {
        const uniqLocations = _.uniq(locations, location => location.FinancingProducts);

        const financingProducts = uniqLocations === null ? null : uniqLocations[0].FinancingProducts;
        let missingProducts = [];
        _.each(uniqLocations, (location) => {
            missingProducts = _.difference(location.FinancingProducts, financingProducts);
            if (missingProducts && missingProducts.length > 0) {
                financingProducts.concat(missingProducts);
            }
        });

        return financingProducts;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/angular/UserDataFactory.js